/**
 * Controls the homepage hero slider carousel.
 */
document.addEventListener('DOMContentLoaded', function() {
    const slider = document.querySelector('.hero-slider');
    if (!slider) return;
    const slides = slider.querySelectorAll('.slide');
    const nav = slider.querySelector('.slider-nav');
    
    let currentSlide = 0;
    let interval;

    // Create navigation dots
    slides.forEach((_, index) => {
        const dot = document.createElement('div');
        dot.classList.add('dot');
        dot.addEventListener('click', () => goToSlide(index));
        nav.appendChild(dot);
    });

    const dots = nav.querySelectorAll('.dot');

    function goToSlide(index) {
        slides[currentSlide].classList.remove('active');
        dots[currentSlide].classList.remove('active');
        
        currentSlide = index;
        
        slides[currentSlide].classList.add('active');
        dots[currentSlide].classList.add('active');
        
        // For mobile only: Update slider container height dynamically
        // if (window.innerWidth <= 1024) {
        //     const activeSlide = slides[currentSlide];
        //     const textContainer = activeSlide.querySelector('.text-content-container');
        //     if (textContainer) {
        //         slider.style.height = (300 + textContainer.offsetHeight) + 'px';
        //     }
        // }
    }

    function nextSlide() {
        const next = (currentSlide + 1) % slides.length;
        goToSlide(next);
    }

    function startAutoplay() {
        interval = setInterval(nextSlide, 7000);
    }

    function stopAutoplay() {
        clearInterval(interval);
    }

    // Initialize first slide and update slider height if on mobile
    goToSlide(0);
    startAutoplay();

    // Optionally pause autoplay on hover
    // slider.addEventListener('mouseenter', stopAutoplay);
    // slider.addEventListener('mouseleave', startAutoplay);
});